import { Flex } from '@modusign/design-system';
import { ReactNode } from 'react';

interface InputWithLabelWrapperProps {
  children: ReactNode | ReactNode[];
  label: ReactNode;
  labelWidth?: string;
}

function InputWithLabelWrapper({
  children,
  label,
  labelWidth = '118px',
}: InputWithLabelWrapperProps) {
  return (
    <Flex alignItems="start" mb={4} p={0} px={4}>
      <Flex mt="8px" position="relative" width={labelWidth}>
        {label}
      </Flex>
      <Flex flexDirection="column" ml={4} width="100%">
        {children}
      </Flex>
    </Flex>
  );
}

export default InputWithLabelWrapper;
